export default "__VITE_ASSET__BEOGix8m__"